import React, { useContext, useEffect, useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "./OfflinePaymentStatus.css";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import {
  getPdf,
  getStudentDetails,
  getStudentDetailsByAdmission,
  resetPdfDetails,
  resetStudentSliceState,
  updateOrderStatus,
} from "../../redux/features/student/studentSlice";
import { resetPaymentStatusSliceState } from "../../redux/features/payment/payment.order.slice";
import { Spinner } from "react-bootstrap";
import { MdFileDownload } from "react-icons/md";
import Logo from "../../assets/images/svbk_logo1.png";
import AppContext from "../../storage/AppContext";
import Header from "../header/Header";
import * as constants from "../../config/config"

const OfflinePaymentStatus = () => {
  const dispatch = useDispatch();

  const studentDetails = useLocation()?.state;

  const [theArray, setTheArray] = useState([]);

  const studentDetail = useSelector((state) => state.student);

  const details = studentDetail.getStudentDetailsByAdmissionDetails;

  const payeeDetails = details?.data;

  const pdfDetails = useSelector(state => state.student.getPdfDetails)

  useEffect(() => {
    dispatch(
      getStudentDetailsByAdmission({
        admission: studentDetails?.admissionNumber,
        academicYear: studentDetails?.academicYear
      })
    );
  }, []);

  useEffect(() => {
    if (details.status === "succeeded" && payeeDetails) {
      payeeDetails?.termFee?.map((eachItem) => {
        if (Object.keys(eachItem)[0] === studentDetails?.term) {
          setTheArray(eachItem[studentDetails?.term]);
        }
      });
    }
    dispatch(updateOrderStatus("idle"));
  }, [details.status]);

  // useEffect(() => {
  //     if (updatedDetails.status === "succeeded") {
  //         dispatch(resetStudentSliceState())
  //         dispatch(resetPaymentStatusSliceState())
  //         window.location.reload(true)
  //     }
  // }, [updatedDetails.status])

  useEffect(() => {
    if(pdfDetails.status === "succeeded"){
      console.log("padfdetails.url",typeof(pdfDetails.url),pdfDetails.url)
      window.open(pdfDetails.url)
      dispatch(resetPdfDetails())
    }
  }, [pdfDetails.status,pdfDetails.url])

  const downloadPdf = async () => {

    dispatch(getPdf({admissionId:studentDetails.admissionNumber, term: studentDetails?.term,  academicYear: studentDetails?.academicYear}))

    // const input = document.getElementById("invoiceHTMLContainer");

    // html2canvas(input, {
    //   logging: true,
    //   letterRendering: 1,
    //   useCORS: true,
    // }).then((canvas) => {
    //   const imgWidth = 208;
    //   const imgHeight = (canvas.height * imgWidth) / canvas.width;
    //   const imgData = canvas.toDataURL("img/png");
    //   const pdf = new jsPDF("p", "mm", "a4");
    //   pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
    //   pdf.save(`receipt ${payeeDetails.admissionNumber}`);
    // });

    // const pdf = new jsPDF("p", "mm", "a4");
    //   pdf.html(doc);
    //   pdf.save(`receipt ${payeeDetails.admissionNumber}`);

  };


  const fullDate = new Date(theArray.date);
  const date = ("0" + fullDate.getDate()).slice(-2);
  const month = ("0" + (fullDate.getMonth() + 1)).slice(-2);
  const year = fullDate.getFullYear();

  const appContext = useContext(AppContext);
  const userDetails = appContext?.userDetails;

  const html = `
        <html>
        
        <head>
            <title>Page Title</title>
            <link rel="stylesheet" type="text/css" href="./htmlcode.css" />
            <style>
                table {
                    font-family: arial;
                    border-collapse: collapse;
                    width: 100%;
                }
        
                td,
                th {
                    border: 1px solid #dddddd;
                    text-align: left;
                    padding: 8px;
                }
        
                td {
                    font-size: 15px;
                    font-weight: 100;
                }
        
                tr:nth-child(odd) {
                    background-color: #f2f2f4;
                }
        
                #detailsPara {
                    margin-left: 10px;
                    font-weight: 100
                }
        
                #detailsPara1 {
                    margin-left: 10px;
                    font-weight: 100;
                    float: right;
                }
        
        
                #hrline {
                    margin-top: 20px
                }
        
                p {
                    font-size: 15px;
                    font-weight: bold
                }
        
                img {
                    border-radius: 35px;
                    display: block;
                    margin-left: auto;
                    margin-right: auto;
                }
        
                .row:after {
                    content: "";
                    display: table;
                    clear: both;
                }
        
                .row {
                    width: 100%
                }
        
                .text-right {
                    text-align: right;
                    word-break: break-word
                }
            </style>
        </head>
        
        <body>
            <div id="main">
                <img src="https://i.ibb.co/9nvbwvZ/svbk-logo.png" alt="Avatar" style="width:70px;height:70px" class="center">
            </div>
            <p style="text-align:center">${studentDetails?.term}</p>
            <P style="text-align:center">${theArray?.paymentStatus ==="Paid" ? "Payment Successful" : "Oops!! Payment Failed"}</p>
            <div>
                <div>
                    <div>
                        <p><span style="width:100px">Payment status</span><span id="detailsPara">:
                                ${theArray?.paymentStatus}</span>
                        </p>
                    </div>
                    <div>
                        <p><span style="width:100px">${!theArray?.offlineDetails ? "TransactionId" : "RecieptId"}</span><span id="detailsPara">: ${!theArray?.offlineDetails ? theArray.transactionId : theArray.offlineDetails?.recieptId}</span></p>
                    </div>
                    <div>
                        <p><span style="width:100px">Payment date</span><span id="detailsPara">:${date + " - " + month + " - " +year}</span></p>
                    </div>
                </div>
            </div>
            <p style="text-decoration:underline">Payer Details :</p>
            <table>
                <tr>
                    <th>Name</th>
                    <td>${payeeDetails.name}</td>
                </tr>
                <tr>
                    <th>Admission</th>
                    <td id="detailsPara">${payeeDetails.admissionNumber}</td>
                </tr>
                <tr>
                    <th>class</th>
                    <td>${payeeDetails.class}</td>
                </tr>
                <tr>
                    <th>Section</th>
                    <td>${payeeDetails.section}</td>
                </tr>
                <tr>
                    <th>Roll No</th>
                    <td>${payeeDetails.rollNo}</td>
                </tr>
            </table>
            <p style="text-decoration:underline">Payment Description :</p>
            <table>
                <tr>
                    <th>Fee</th>
                    <td>${theArray.paidAmount ? theArray.paidAmount : theArray.amount}</td>
                </tr>
            </table>
            <hr id="hrline">
            <div>
                <p><span style="width:60px">Website</span><span id="detailsPara">: svbk@gmail.com</span></p>
            </div>
            <div>
                <p><span style="width:60px">Address</span><span id="detailsPara">: Sri Venkateswara Bala Kuteer,
                        Syamala Nagar, 3rd Guntur-522006, AP</span></p>
            </div>
            <div>
                <p><span style="width:85px;padding-right:12px">Phone</span><span id="detailsPara">: 8632232405</span></p>
            </div>
            <div style="background-color:#4d90df">
                <p id="detailsPara" style="text-align:center;color:black;padding:10px;font-size:16px">In case of any issues
                    please call us at <span style="font-weight:bold">8632232405</span> or drop an email at <span
                        style="font-weight:bold">jayasreed@svbalakuteer.com</span></p>
            </div>
        </body>
        
        </html>`  
        
        let parser = new DOMParser();
        let doc = parser.parseFromString(html, 'text/html');

    console.log("doc",doc)
  return (
    <>
    {userDetails?.active && <Header />}
      {(details.status === "loading" || pdfDetails.status === "loading" || theArray.length === 0) ? (
        <div
          style={{ minHeight: "80vh" }}
          className="d-flex justify-content-center align-items-center"
        >
          <Spinner animation="border" role="status"></Spinner>
        </div>
      ) : (
        <div className="d-flex flex-column" id="invoiceHTMLContainer">
          <div className="total-details">
            {!userDetails?.active && <img src={Logo} alt="Logo" className="svbk-invoice-logo" />}
            <div className="invoice-body">
              <div className="invoice-total-cont">
                <div className="invoice-card">
                  <h3 className="col-head">Invoice</h3>
                  {!theArray?.offlineDetails ? (
                    <div className="invoice-row">
                      <p className="left-row row-text">TransactiontId</p>
                      <span className="colon">:</span>
                      <p className="right-row row-text">
                        {theArray?.transactionId}
                      </p>
                    </div>
                  ) : (
                    <div className="invoice-row">
                      <p className="left-row row-text">RecieptId</p>
                      <span className="colon">:</span>
                      <p className="right-row row-text">
                        {theArray?.offlineDetails?.recieptId}
                      </p>
                    </div>
                  )}
                  <div className="invoice-row">
                    <p className="left-row row-text">Payment Status</p>
                    <span className="colon">:</span>
                    <p className="right-row row-text">
                      {theArray?.paymentStatus}
                    </p>
                  </div>
                  <div className="invoice-row">
                    <p className="left-row row-text">Payment Date</p>
                    <span className="colon">:</span>
                    <p className="right-row row-text">{`${date}-${month}-${year}`}</p>
                  </div>

                  {/* <div className="invoice-row">
                    <p className="left-row row-text">Phone</p>
                    <span className="colon">:</span>
                    <p className="right-row row-text">
                      {payeeDetails.phoneNumber}
                    </p>
                  </div> */}

                </div>
                <div className="invoice-card address-card">
                  {/* <h3 className="col-head">Billed to</h3> */}
                  <div className="invoice-row">
                    <p className="left-row row-text">Website</p>
                    <span className="colon">:</span>
                    <p className="right-row row-text">svbk@gmail.com</p>
                  </div>
                  <div className="invoice-row">
                    <p className="left-row row-text">Address</p>
                    <span className="colon">:</span>
                    <p className="right-row row-text">
                     {constants.address}
                    </p>
                  </div>
                </div>
                <button
                  className="download-button sm-download-button"
                  onClick={downloadPdf}
                >
                  Download Invoice
                </button>
              </div>
              <div className="amount-details">
                <div className="invoice-row p-0 pb-3">
                  <p className="left-row row-text">Amount Paid</p>
                </div>
                {/* <p className="right-row row-text-id">{theArray?.transactionId ? theArray?.transactionId  : theArray?.offlineDetails?.recieptId}</p> */}
                <h5 className="pb-3">{!theArray?.offlineDetails ? `Rs ${theArray.paidAmount}` : "Paid in alternative mode refer to original receipt."}</h5>
                <p className="paid-date pb-3">
                  Date: {`${date}-${month}-${year}`}
                </p>
                <button className="download-button" onClick={downloadPdf}>
                  Download
                </button>
              </div>
            </div>
            <div className="w-100 p-3">
              <div className="invoice-card w-100">
                <h3 className="col-head">Payer Details</h3>
                <div className="table-from-medium-devices">
                  <table className="p-3">
                    <tr style={{ borderBottom: "1px solid #ddd" }}>
                      <td>Name</td>
                      <td>Admission</td>
                      <td>Class</td>
                      <td>Section</td>
                      <td>Roll NO</td>
                    </tr>
                    <tr
                      style={{
                        paddingBottom: "20px",
                        borderBottom: "1px solid #ddd",
                      }}
                    >
                      <td style={{ paddingBottom: "40px", paddingTop: "20px" }}>
                        {payeeDetails.name}
                      </td>
                      <td style={{ paddingBottom: "40px", paddingTop: "20px" }}>
                        {payeeDetails.admissionNumber}
                      </td>
                      <td style={{ paddingBottom: "40px", paddingTop: "20px" }}>
                        {payeeDetails.class}
                      </td>
                      <td style={{ paddingBottom: "40px", paddingTop: "20px" }}>
                        {payeeDetails.section}
                      </td>
                      <td style={{ paddingBottom: "40px", paddingTop: "20px" }}>
                        {payeeDetails.rollNo}
                      </td>
                    </tr>
                  </table>
                  {!theArray?.offlineDetails && <div className="footer-fee mt-2">
                    <p className="fee-p">Fee</p>
                    <p className="rs-p">Rs,{theArray.amount}</p>
                  </div>}
                </div>
                <div className="table-upto-small-devices">
                  <div className="invoice-row">
                    <p className="left-row row-text">Name</p>
                    <p className="right-row row-text">{payeeDetails.name}</p>
                  </div>
                  <div className="invoice-row">
                    <p className="left-row row-text">Admission</p>
                    <p className="right-row row-text">
                      {payeeDetails.admissionNumber}
                    </p>
                  </div>
                  <div className="invoice-row">
                    <p className="left-row row-text">Class</p>
                    <p className="right-row row-text">{payeeDetails.class}</p>
                  </div>
                  <div className="invoice-row">
                    <p className="left-row row-text">Section</p>
                    <p className="right-row row-text">
                      {payeeDetails.section}
                    </p>
                  </div>
                  <div className="invoice-row">
                    <p className="left-row row-text">Roll No</p>
                    <p className="right-row row-text">{payeeDetails.rollNo}</p>
                  </div>
                  {!theArray?.offlineDetails && <div className="invoice-row">
                    <p className="left-row row-text dark-text">Fee</p>
                    <p className="right-row row-text">Rs,{theArray.amount}</p>
                  </div>}
                </div>
              </div>
            </div>
          </div>
          <div className="footer-invoice p-3">
            <p className="footer-text">
              In case of any issues please call us at {constants.phoneNumber} or drop an
              email at {constants.email}.
            </p>
          </div>
        </div>
      )}
    </>
  );
};
export default OfflinePaymentStatus;
